import "./Partners.scss";
import NvidiaLogo from "../../assets/images/partners/nvidia-logo.svg";
import IbmLogo from "../../assets/images/partners/ibm-logo.svg";
import OpenAILogo from "../../assets/images/partners/openai-logo.svg";
import EthereumLogo from "../../assets/images/partners/ethereum-logo.svg";
import FetchAILogo from "../../assets/images/partners/fetchai-logo.svg";
import SingularityNetLogo from "../../assets/images/partners/singularitynet-logo.svg";

export default function Partners() {
	return (
		<div className="partners">
			<div className="partners-content-wrapper content-wrapper-lg">
				<ul className="partner-items">
					<li className="partner-item">
						<div className="partner">
							<img
								className="partner-logo"
								src={NvidiaLogo}
								alt="Nvidia"
							/>
							<div className="partner-title">Nvidia</div>
						</div>
					</li>
					<li className="partner-item">
						<div className="partner">
							<img
								className="partner-logo"
								src={IbmLogo}
								alt="IBM"
							/>
							<div className="partner-title">IBM</div>
						</div>
					</li>
					<li className="partner-item">
						<div className="partner">
							<img
								className="partner-logo"
								src={OpenAILogo}
								alt="OpenAI"
							/>
							<div className="partner-title">OpenAI</div>
						</div>
					</li>
					<li className="partner-item">
						<div className="partner">
							<img
								className="partner-logo"
								src={EthereumLogo}
								alt="Ethereum"
							/>
							<div className="partner-title">Ethereum</div>
						</div>
					</li>
					<li className="partner-item">
						<div className="partner">
							<img
								className="partner-logo"
								src={FetchAILogo}
								alt="Fetch AI"
							/>
							<div className="partner-title">Fetch AI</div>
						</div>
					</li>
					<li className="partner-item">
						<div className="partner">
							<img
								className="partner-logo"
								src={SingularityNetLogo}
								alt="Singularity Net"
							/>
							<div className="partner-title">Singularity Net</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
}
